import React, { useEffect, useState } from 'react';

import { deepCloneArray, deepCloneObject, func_validation, isArrayEmpty, isArrayNotEmpty, isComparisonOfBothArraysEqual, isFunction } from 'functions';

import "assets/scss/components/form/listBoxTransfer.scss";
import { ListBox } from './ListBox';


export function ListBoxTransfer(props) {
    const { 
        className, 

        leftBoxTitle,
        leftBoxList: leftBoxList_props,
        leftActionButtonTxt,
        leftListBoxAction_status,
        leftListBoxData_requesting,
        leftListBoxAction_requesting,
        leftListBoxOptions,
        leftBox_onClick,
        updateParentLeftBoxList,
    

        rightBoxTitle,
        rightBoxList: rightBoxList_props,
        rightActionButtonTxt,
        rightListBoxAction_status,
        rightListBoxData_requesting,
        rightListBoxAction_requesting,
        rightListBoxOptions,
        rightBox_onClick,
        updateParentRightBoxList,
    } = props;

    // Validate Props
    let leftListBoxOptions_formatted = func_validation.isObjectNotEmpty(leftListBoxOptions)? leftListBoxOptions:{};
    let rightListBoxOptions_formatted = func_validation.isObjectNotEmpty(rightListBoxOptions)? rightListBoxOptions:{};

    let leftActionButtonTxt_validated = func_validation.isStringTrimNotEmpty(leftActionButtonTxt)? leftActionButtonTxt:"";
    let rightActionButtonTxt_validated = func_validation.isStringTrimNotEmpty(rightActionButtonTxt)? rightActionButtonTxt:"";

    const [leftBoxList, setLeftBoxList] = useState(leftBoxList_props);
    const [rightBoxList, setRightBoxList] = useState(rightBoxList_props);

    function getLeftListBoxList() {
        if (props.getLeftListBoxList)
            props.getLeftListBoxList();
    }
    function getRightListBoxList() {
        if (props.getRightListBoxList)
            props.getRightListBoxList();
    }
    useEffect(() => {
        getLeftListBoxList();
        getRightListBoxList();
    }, []);
    useEffect(() => {
        setLeftBoxList(leftBoxList_props);
        setRightBoxList(rightBoxList_props);
    }, [leftBoxList_props, rightBoxList_props]);
    useEffect(() => {
        if (func_validation.isBooleanTrueNotNullUndefined(props.leftListBoxAction_status) ||
            func_validation.isBooleanTrueNotNullUndefined(props.rightListBoxAction_status)) {
                getLeftListBoxList();
                getRightListBoxList();
            }
    }, [leftListBoxAction_status, rightListBoxAction_status]);


    function handleActionClick({ 
        selectedData = [], selectedFullDetailsList = [], onClick, currentBoxList = [], setCurrentBoxList = () => {},
        otherBoxList = [], setOtherBoxList = () => {}, updateParentCurrentBoxList = () => {}, updateParentOtherBoxList = () => {}
    }) {
        if (isFunction(onClick)) onClick(selectedData);
        else if (isArrayNotEmpty(selectedFullDetailsList)) {
            // update current box list
            let newCurrentBoxList = updateCurrentBoxList(currentBoxList, selectedFullDetailsList);
            function updateCurrentBoxList(list, selectedList) {
                let newList = deepCloneArray(list);
                if (isArrayNotEmpty(newList)) {
                    for (let i = 0; i < newList.length; i++) {
                        let details = newList[i];
                        details.isSelected = false;
                        details.isExpanded = false;

                        // Find match
                        if (isArrayNotEmpty(selectedList)) {
                            selectedList.map((selectedDetails) => {
                                if (details?.label === selectedDetails?.label) {
                                    let subList = updateCurrentBoxList(details?.subList, selectedDetails?.subList);

                                    if (isArrayEmpty(subList)) {
                                        newList.splice(i, 1); 
                                        i--;
                                    }
                                    else {
                                        details.subList = subList;
                                    }
                                }
                            })
                        }
                    }
                }
                return newList;
            }
            setCurrentBoxList(newCurrentBoxList);
            updateParentCurrentBoxList(newCurrentBoxList);

            let newList = updateList(otherBoxList, selectedFullDetailsList);
            function updateList(list, selectedList) {
                let newList = deepCloneArray(list);
                let newSelectedList = deepCloneArray(selectedList);
                if (isArrayNotEmpty(newList)) {
                    let isMatchFound = false;
                    newList.map((details) => {
                        details.isSelected = false;
                        details.isExpanded = false;

                        // Remove matching items
                        if (isArrayNotEmpty(newSelectedList)) {
                            newSelectedList.map((selectedDetails, idx) => {
                                selectedDetails.isSelected = false;
                                selectedDetails.isExpanded = false;

                                if (details?.label === selectedDetails?.label) {
                                    isMatchFound = true;

                                    // Check if sub list exists
                                    let subList = updateList(details?.subList, selectedDetails?.subList);

                                    if (isArrayEmpty(subList)) {
                                        newSelectedList.splice(idx, 1);
                                    }
                                    else {
                                        details.subList = subList;
                                    }
                                }
                            })
                        }
                    });

                    if (!isMatchFound)
                        newList = newList.concat(newSelectedList);
                }
                else newList = deepCloneArray(selectedList);

                return newList;
            }

            // Sort list
            newList.sort((a, b) => {
                let label1 = a?.label;
                let label2 = b?.label;
                if (label1 > label2) return 1;
                if (label1 < label2) return -1;
                return 0;
            });
            setOtherBoxList(newList);
            updateParentOtherBoxList(newList);
        }
    }
    function handleLeftBox_OnClick(selectedData, selectedFullDetailsList) {
        handleActionClick({
            selectedData, selectedFullDetailsList, 
            onClick: leftBox_onClick, 
            currentBoxList: leftBoxList, 
            setCurrentBoxList: setLeftBoxList,
            otherBoxList: rightBoxList, 
            setOtherBoxList: setRightBoxList,

            updateParentCurrentBoxList: updateParentLeftBoxList,
            updateParentOtherBoxList: updateParentRightBoxList 
        })
    }

    function handleRightBox_OnClick(selectedData, selectedFullDetailsList) {
        handleActionClick({
            selectedData, selectedFullDetailsList, 
            onClick: rightBox_onClick, 
            currentBoxList: rightBoxList, 
            setCurrentBoxList: setRightBoxList,
            otherBoxList: leftBoxList, 
            setOtherBoxList: setLeftBoxList,

            updateParentCurrentBoxList: updateParentRightBoxList,
            updateParentOtherBoxList: updateParentLeftBoxList 
        })
    }

    return (
        <div className={"component-list-box-transfer d-flex align-items-center " + 
                (className? className + " ":"")}>
            <div className="component-list-box-transfer__left-box w-50">
                <ListBox
                    title={leftBoxTitle}
                    actionButtonTxt={leftActionButtonTxt_validated}
                    list={leftBoxList}
                    isListLoading={leftListBoxData_requesting}
                    isActionLoading={leftListBoxAction_requesting}

                    onActionClick={handleLeftBox_OnClick}

                    isActionVisible

                    {...leftListBoxOptions_formatted}
                />
            </div>

            <div className="component-list-box-transfer__right-box w-50">
                <ListBox
                    title={rightBoxTitle}
                    actionButtonTxt={rightActionButtonTxt_validated}
                    list={rightBoxList}
                    isListLoading={rightListBoxData_requesting}
                    isActionLoading={rightListBoxAction_requesting}

                    onActionClick={handleRightBox_OnClick}

                    isActionVisible

                    {...rightListBoxOptions_formatted}
                />
            </div>
        </div>
    )
}